var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Spinner } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import customerIdAsKey from '../../auth/customerIdAsKey';
import InvoicePaymentButton from './InvoicePaymentButton';
import InvoiceTable from './InvoiceTable';
import { injectStores } from '../../util/StoresUtil';
let InvoiceList = class InvoiceList extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "invoiceStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    componentDidMount() {
        return this.invoiceStore.fetchInvoices();
    }
    render() {
        const { translate } = this.translateStore;
        if (this.invoiceStore.isFetching()) {
            return React.createElement(Spinner, null);
        }
        if (!this.invoiceStore.hasMandates) {
            return React.createElement("p", null, translate('billing.no-mandates'));
        }
        if (this.invoiceStore.hasError() || !this.invoiceStore.invoicesWrapper.invoices || !this.invoiceStore.invoicesWrapper.invoices.length) {
            return React.createElement("p", null, translate('diilcrm.no-bills'));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(InvoiceTable, null),
            React.createElement(InvoicePaymentButton, { totalAmountToPay: this.invoiceStore.invoicesWrapper.totalAmountToPay })));
    }
};
InvoiceList = __decorate([
    customerIdAsKey,
    injectStores,
    observer
], InvoiceList);
export default InvoiceList;
